<template>
  <div class="main-content">
    <div class="substrate --for-promo --with-img">
      <div class="substrate__bg-wrapper">
        <picture>
          <source
            srcset="~/assets/img/main/main-promo-bg.webp"
            type="image/webp"
          />
          <img :src="require(`~/assets/img/main/main-promo-bg.png`)" alt="" />
        </picture>
      </div>
      <div class="container">
        <MainPromoBlockMobile>
          <template #controls>
            <VButtonLinkMTSV2
              href="/user/organizer"
              class="main-promo__controls_btn --violet-gradient --m"
            >
              <span>Попробовать бесплатно</span>
            </VButtonLinkMTSV2>
            <VButtonLinkMTSV2
              href="/user/demo/"
              class="main-promo__controls_btn --white --m"
            >
              <span>Оставить заявку</span>
              <VIconMTS
                :name="'mts/icon-mts--arrow-link-right'"
                width="16"
                height="16"
              />
            </VButtonLinkMTSV2>
          </template>
        </MainPromoBlockMobile>
      </div>
    </div>
    <div class="container">
      <LazyProductsListBlockMobile @selected-section="handlerSelectedSection" />
    </div>
    <div class="substrate --gray-gradient">
      <div class="container">
        <LazyProductsBlockMobile :name-selected-section="nameSelectedSection" />
        <LazyLeaderVKSBlockMobile />
      </div>
    </div>

    <div class="substrate --with-img">
      <div class="substrate__bg-wrapper">
        <picture>
          <source
            srcset="~/assets/img/main/main-promo-bg.webp"
            type="image/webp"
          />
          <img :src="require(`~/assets/img/main/main-promo-bg.png`)" alt="" />
        </picture>
      </div>
      <div class="container">
        <LazyOnPremiseBlockMobile />
      </div>
    </div>
    <div class="container">
      <LazyReviewsBlockMobile />
      <LazyAdvantagesBlockMobile />
    </div>
    <div class="substrate --gray-bg">
      <div class="container">
        <LazyFAQBlockMobile />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/mixins/EventBus'
import MainMixin from '~/components/Page/Main/MainMixin'
import LazyOnPremiseBlockMobile from '~/components/Mobile/Main/Lazy/LazyOnPremiseBlockMobile'
import LazyLeaderVKSBlockMobile from '~/components/Mobile/Main/Lazy/LazyLeaderVKSBlockMobile'
import LazyProductsBlockMobile from '~/components/Mobile/Main/Lazy/LazyProductsBlockMobile'
import LazyFAQBlockMobile from '~/components/Mobile/Main/Lazy/LazyFAQBlockMobile'
import LazyAdvantagesBlockMobile from '~/components/Mobile/Main/Lazy/LazyAdvantagesBlockMobile'
import LazyReviewsBlockMobile from '~/components/Mobile/Main/Lazy/LazyReviewsBlockMobile'
import LazyProductsListBlockMobile from '~/components/Mobile/Main/Lazy/LazyProductsListBlockMobile'
import MainPromoBlockMobile from '~/components/Mobile/Main/MainPromoBlockMobile'
import VButtonLinkMTSV2 from '~/components/Common/MTS/VButtonLinkMTSV2.vue'
import VIconMTS from '~/components/Common/MTS/VIconMTS.vue'

export default {
  name: 'MainPageMobile',
  components: {
    LazyOnPremiseBlockMobile,
    LazyLeaderVKSBlockMobile,
    LazyProductsBlockMobile,
    LazyFAQBlockMobile,
    LazyAdvantagesBlockMobile,
    LazyReviewsBlockMobile,
    LazyProductsListBlockMobile,
    MainPromoBlockMobile,
    VButtonLinkMTSV2,
    VIconMTS
  },
  mixins: [EventBus, MainMixin],
}
</script>

<style lang="scss" scoped>
.main-content {
  font-family: $font-mts-compact;

  .container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .substrate {
    &.--with-img {
      padding: 32px 0;
      position: relative;

      .substrate__bg-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    &.--gray-gradient {
      background: linear-gradient(180deg, #f2f3f7 0%, #ffffff 100%);
    }

    &.--gray-bg {
      background: $color-gray-2;
    }
    &.--for-promo {
      padding: 20px 0;
    }
  }
}
</style>
